<template>
    <div></div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'userLogout',
  props: ['isShowingTermAndCondition'],
  mounted () {
    this.loadUserLogout()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'resetSelectedFactes'
    ]),

    loadUserLogout () {
      this.resetSelectedFactes()
      if (!this.isShowingTermAndCondition) {
        this.loadLogDashboardActivity({action: 'logout', page: 'logout', link: ''})
      }
      let openId = localStorage.getItem('openId')
      let currentRole = localStorage.getItem('userrole')
      localStorage.clear()
      if (openId === 'PRAGYA_TEMP_OPEN_ID_FOR_NU') {
        window.location.href = '/sso/nu'
      } else {
        this.redirectToLogin(currentRole)
      }
      /*
      if (role === 'Employer Admin') {
        window.location.href = '/landing/views/login.html'
      } else {
        window.location.href = '/landing/views/nunav-landing.html'
      }
      */
    },
    redirectToLogin (currentRole) {
      if (this.institution) {
        let ssoPath = this.institution.path
        let shortName = this.institution.shortName
        let signupLink = this.institution.selfRegistrationLink
        let logoutUrl = this.institution.ssoLogoutUrl
        if(logoutUrl && currentRole === 'Student') {
            window.location.href = logoutUrl
        } else if(ssoPath && ssoPath.length>1 && currentRole === 'Student'){
            window.location.href = '/sso/'+ssoPath
        } else if (shortName && signupLink && shortName.length > 0 && signupLink.length > 0) {
          window.location.href = '/signin/' + shortName
        } else {
          this.$root.$emit('serviceAvailable', true)
        }
      } else {
        this.$root.$emit('serviceAvailable', true)
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/user/components/UserLogout.vue